import { useBrandStore } from '../../context';

import FontUploader from './FontUploader';
import FontInput from './FontInput';
import Card from '../../../../card/Card';

export default function FontUploaders() {
  const savedSiteFont = useBrandStore((state) => state.savedSiteFont);
  const savedSiteFontSecondary = useBrandStore((state) => state.savedSiteFontSecondary);
  const savedSiteFontTertiary = useBrandStore((state) => state.savedSiteFontTertiary);
  const setSiteFont = useBrandStore((state) => state.setSiteFont);
  const setSiteFontSecondary = useBrandStore((state) => state.setSiteFontSecondary);
  const setSiteFontTertiary = useBrandStore((state) => state.setSiteFontTertiary);

  const setSavedSiteFont = useBrandStore((state) => state.setSavedSiteFont);
  const setSavedSiteFontSecondary = useBrandStore((state) => state.setSavedSiteFontSecondary);
  const setSavedSiteFontTertiary = useBrandStore((state) => state.setSavedSiteFontTertiary);

  const setIsDeleteSiteFont = useBrandStore((state) => state.setIsDeleteSiteFont);
  const setIsDeleteSiteFontSecondary = useBrandStore((state) => state.setIsDeleteSiteFontSecondary);
  const setIsDeleteSiteFontTertiary = useBrandStore((state) => state.setIsDeleteSiteFontTertiary);

  return (
    <div className="db-dashboard-font-files">
      <div className="upload-section">
        <div className="d-flex flex-column gap-2">
          <label className="title">Font (Sans)</label>
          <FontUploader fontUrl={savedSiteFont} onSetMedia={setSiteFont} onSetSavedMedia={setSavedSiteFont} onDeleteMedia={setIsDeleteSiteFont} />
        </div>
        <div className="d-flex flex-column gap-2">
          <label className="title">Font (Serif)</label>
          <FontUploader
            fontUrl={savedSiteFontSecondary}
            onSetMedia={setSiteFontSecondary}
            onSetSavedMedia={setSavedSiteFontSecondary}
            onDeleteMedia={setIsDeleteSiteFontSecondary}
          />
        </div>
        <div className="d-flex flex-column gap-2">
          <label className="title">Font (Mono)</label>
          <FontUploader
            fontUrl={savedSiteFontTertiary}
            onSetMedia={setSiteFontTertiary}
            onSetSavedMedia={setSavedSiteFontTertiary}
            onDeleteMedia={setIsDeleteSiteFontTertiary}
          />
        </div>
      </div>
      <div className="text-center">
        <span className="text-muted">Please upload variable fonts only.</span>
      </div>
      <Card className="rounded">
        <FontInput />
      </Card>
    </div>
  );
}
